import { render, staticRenderFns } from "./tablePerformance.vue?vue&type=template&id=2169121e&scoped=true&"
import script from "./tablePerformance.vue?vue&type=script&lang=js&"
export * from "./tablePerformance.vue?vue&type=script&lang=js&"
import style0 from "./tablePerformance.vue?vue&type=style&index=0&id=2169121e&lang=scss&scoped=true&"
import style1 from "./tablePerformance.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2169121e",
  null
  
)

export default component.exports